module.exports = __webpack_public_path__ + "img/case_finance.1bf50f64.png";